import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { config } from "@/lib/config";
import VideoPlayer from "@/components/video-player";
import { EventSchema, BreadcrumbSchema } from '@/components/StructuredData'

export default function LelekSzinei() {
  const pageRef = useRef<HTMLDivElement>(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (pageRef.current) {
      setShowVideo(true);
    }
  }, []);

  const videoSources = [
    {
      src: `${config.basePath}/video/lelek-szinei-hd1080p.mp4`,
      type: "video/mp4",
    },
    {
      src: `${config.basePath}/video/lelek-szinei-sd720p.mp4`,
      type: "video/mp4",
    },
    {
      src: `${config.basePath}/video/lelek-szinei-sd640p.mp4`,
      type: "video/mp4",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Lélek Színei kiállítás | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások" />
        <link rel="canonical" href="https://beart.hu/lelek-szinei" />
      </Helmet>
      
      {/* Structured Data */}
      <EventSchema 
        name="Lélek Színei Kiállítás"
        description="Művészetterápiás kiállítás és interaktív alkotás az Optika Galériában. A kiállítás a lélek színeit mutatja be művészetterápiás eszközökkel."
        startDate="2024-01-01T10:00:00+01:00"
        endDate="2024-12-31T18:00:00+01:00"
        location={{
          name: "Optika Galéria",
          address: {
            streetAddress: "Bartók Béla út 22.",
            addressLocality: "Budapest",
            postalCode: "1111",
            addressCountry: "HU"
          }
        }}
        organizer={{
          name: "BeArt Művészetterápia",
          url: "https://beart.hu"
        }}
        eventStatus="EventScheduled"
        eventAttendanceMode="OfflineEventAttendanceMode"
      />
      <BreadcrumbSchema 
        items={[
          { name: "Főoldal", url: "https://beart.hu" },
          { name: "Lélek Színei Kiállítás", url: "https://beart.hu/lelek-szinei" }
        ]} 
      />
      
      <main ref={pageRef}>
        {showVideo && (
          <div>
            <VideoPlayer videoSrc={videoSources} loop={false} />
          </div>
        )}
        <h1 className="pointer-events-none fixed right-0 top-[62px] z-40 hidden justify-center rounded-3xl bg-white bg-opacity-30 p-2 text-center text-3xl font-bold backdrop-blur-md lg:flex">
          <img
            src={`${config.basePath}/images/lelek-szinei-kiallitas.png`}
            width={200}
            alt="Lélek színei kiállítás"
          />
        </h1>
        <div className="canva1">
          <iframe
            loading="lazy"
            className="canva2"
            src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGGylBvg-M&#x2F;BRfWF_0ruACHUgYmhQ_QLg&#x2F;view?embed"
            allowFullScreen={true}
            allow="fullscreen"
          ></iframe>
        </div>
      </main>
    </>
  )
}
